import script from "./ApplicationsSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsSearch.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__